module.exports = __webpack_public_path__ + "static/img/banner.b67e8b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/产品及服务/DNA提取+PCR扩增+测序/banner.png
// module id = VlKX
// module chunks = 16